export default __webpack_public_path__ + "icons/mstile-310x310-5df5c4670f8b7932b082171c38c215b2.png";